import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Clock, ShieldCheck, XCircle, LogOut, RefreshCw, Headset } from "lucide-react";
import { ContractPanel } from "@/components/ContractPanel";

export default function PendingApproval() {
  const { user, logout, refresh } = useAuth();
  const navigate = useNavigate();
  const rejected = user?.status === "rejected";

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6 hero-grid">
      <Card className="max-w-md w-full p-8 text-center" data-testid="pending-approval">
        <div className={`w-16 h-16 rounded-2xl mx-auto flex items-center justify-center mb-5 ${rejected ? "bg-destructive/10 text-destructive" : "bg-accent/10 text-accent"}`}>
          {rejected ? <XCircle className="w-8 h-8" /> : <Clock className="w-8 h-8" />}
        </div>
        <h1 className="font-heading text-2xl font-extrabold mb-2">
          {rejected ? "تم رفض الحساب" : "حسابك قيد المراجعة"}
        </h1>
        <p className="text-muted-foreground leading-relaxed mb-6">
          {rejected
            ? "عذراً، لم يتم اعتماد حسابك من الإدارة. يرجى التواصل مع فريق الدعم لمزيد من التفاصيل."
            : "شكراً لتسجيلك! يقوم فريق الإدارة بمراجعة بيانات حسابك حالياً. سيتم إشعارك فور اعتماد الحساب لتتمكن من استقبال الطلبات."}
        </p>
        <ContractPanel />
        {!rejected && (
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground mb-6 bg-muted/50 rounded-xl p-3">
            <ShieldCheck className="w-4 h-4 text-primary" />
            الاعتماد يتم من لوحة تحكم الإدارة بعد مراجعة المعلومات
          </div>
        )}
        <div className="flex flex-col gap-2">
          {!rejected && (
            <Button variant="outline" className="rounded-xl gap-2" onClick={refresh} data-testid="refresh-status-btn">
              <RefreshCw className="w-4 h-4" /> تحديث الحالة
            </Button>
          )}
          <Button variant="outline" className="rounded-xl gap-2" onClick={() => navigate("/support")} data-testid="pending-support-btn">
            <Headset className="w-4 h-4" /> تواصل مع خدمة العملاء
          </Button>
          <Button variant="ghost" className="rounded-xl gap-2 text-muted-foreground" onClick={() => { logout(); navigate("/"); }} data-testid="pending-logout">
            <LogOut className="w-4 h-4" /> تسجيل الخروج
          </Button>
        </div>
      </Card>
    </div>
  );
}
